import React, { createContext, Dispatch, ReducerState, useContext, useReducer } from 'react'
import { initialState, IState, TReducer } from '../../store/reducer'

// Prepares the dataLayer
export const StateContext = createContext<{ state: IState; dispatch: Dispatch<any> }>({
  state: initialState,
  dispatch: () => null
})

interface IStateProvider {
  reducer: TReducer
  initialState: IState
  children: JSX.Element
}

// Wrap our app and provide the Data layer
export const StateProvider = ({ reducer, initialState, children }: IStateProvider) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  return <StateContext.Provider value={{ state, dispatch }}>{children}</StateContext.Provider>
}

// Pull information from the data layer
export const useStateValue = () => useContext(StateContext)
